import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router'
import { Breadcrumbs } from '@/shared/ui/breadcrumbs'

// Панель детали грузится на переходе — не тянем её в стартовый бандл.
const PoolDetail = lazyRouteComponent(() => import('@/widgets/pool-detail'), 'PoolDetail')

export const Route = createFileRoute('/telephony/pools/$poolId')({
  component: PoolPage,
})

function PoolPage() {
  const { poolId } = Route.useParams()
  return (
    <>
      <Breadcrumbs current={poolId} />
      <PoolDetail poolId={poolId} />
    </>
  )
}
